<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="Branch" class="col-sm-2 col-form-label font-weight-bold">Branch</label>
            <div class="col-sm-6">
              <select name="tahun" id="branch" v-model="branch" class="custom-select custom-select-sm">
                <option :key="bran.id" v-for="bran in branchs" :value="bran.id">{{bran.name}}</option>
              </select>
            </div>
          </div>
          <div class="from-group row">
            <label for="" class="col-sm-2 col-form-label font-weight-bold">Date</label>
            <div class="col-sm-6">
              <template v-if="selected == 'normal'">
                <date-picker v-model="date" lang="en" format="MMMM YYYY" type="month"></date-picker>
              </template>
              <template v-else-if="selected == 'custom'">from: 
                <date-picker v-model="start" lang="en" format="DD/MM/YYYY"></date-picker>
                &nbsp; to: 
                <date-picker v-model="end" lang="en" format="DD/MM/YYYY"></date-picker>
              </template>
              <br>
              <b-form-group>
                <b-form-radio-group
                  v-model="selected"
                  :options="options"
                   name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-6">
              <button @click="submit" class="btn btn-primary">Submit</button>
            </div>
          </div>
          <b-row>
            <template v-if="listInsentif.length > 0">
              <b-alert show>
                <span>Total Pasbar : <span class="href" @click="OpenDetail('', 'Total Pasbar', manager.list_pasbar, (manager.total_pasbar * manager.insentif_perticket), true)"><b>{{manager.total_pasbar}} </b></span>
                </span> <br>
                <span>Total Relocation : <span class="href" @click="OpenDetail('', 'Total Relocation', manager.list_relocation, (manager.total_relocation * manager.insentif_perticket), true)"><b>{{manager.total_relocation}} </b></span> </span><br>
                {{manager.note | plusRupiah}}
              </b-alert>
              <div class="table-responsive b-table-sticky-header">
                <table class="table b-table table-bordered table-striped  b-table-no-border-collapse">
                  <thead>
                  <tr>
                    <th rowspan="2">No</th>
                    <th class="name" rowspan="2">Nama</th>
                    <th colspan="2">Bongkar</th>
                    <th colspan="4">Survey</th>
                    <th colspan="2">Pasbar</th>
                    <th colspan="2">Relocation</th>
                    <th rowspan="2" class="price">Total Insentif</th>
                  </tr>
                  <tr>
                      <th class="topHeader">Jumlah</th>
                      <th class="topHeader price">Insentif</th>
                      <th class="topHeader">Jumlah</th>
                      <th class="topHeader price">Insentif</th>
                      <th class="topHeader">Jumlah Win</th>
                      <th class="topHeader price">Insentif Win</th>
                      <th class="topHeader">Jumlah</th>
                      <th class="topHeader price">Insentif</th>
                      <th class="topHeader">Jumlah</th>
                      <th class="topHeader price">Insentif</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(data, i) in listInsentif">
                    <tr :key="'insentif-' + i">
                     <td>{{i +1 }}</td>
                     <td class="name">{{data.name}}</td>
                     <td>
                         <span class="href" @click="OpenDetail(data.name, 'bongkar', data.bongkar_detail, data.bongkar_insentif)">
                            {{data.bongkar}}
                         </span>
                     </td>
                     <td class="price">{{data.bongkar_insentif | pointmoney}}</td>
                     <td>
                         <span class="href" @click="OpenDetail(data.name, 'survey', data.survey_detail, data.survey_insentif)">
                         {{data.survey}}
                         </span>
                    </td>
                     <td class="price">{{data.survey_insentif | pointmoney}}</td>
                     <td>
                         <span class="href" @click="OpenDetail(data.name, 'survey win', data.survey_win_detail, data.survey_win_insentif)">
                         {{data.survey_win}}
                         </span>
                    </td>
                     <td class="price">{{data.survey_win_insentif | pointmoney}}</td>
                     <td>
                         <span class="href" @click="OpenDetail(data.name, 'pasbar', data.pasbar_detail, data.pasbar_insentif)">
                         {{data.pasbar}}
                         </span>
                    </td>
                     <td class="price">{{data.pasbar_insentif | pointmoney}}</td>
                     <td>
                         <span class="href" @click="OpenDetail(data.name, 'relocation', data.reloc_detail, data.reloc_insentif)">
                         {{data.reloc}}
                         </span>
                    </td>
                     <td class="price">{{data.reloc_insentif | pointmoney}}</td>
                     <td class="price"> 
                         {{(data.bongkar_insentif + data.survey_insentif + data.survey_win_insentif + data.pasbar_insentif + data.reloc_insentif) | pointmoney }}</td>
                    </tr>
                  </template>
                  <tr>
                      <td colspan="2" class="bottom-sticky"><strong>TOTAL</strong></td>
                      <td class="bottom-sticky">{{total.bongkar}}</td>
                      <td class="price bottom-sticky">{{total.bongkar_insentif | pointmoney}}</td>
                      <td class="bottom-sticky">{{total.survey}}</td>
                      <td class="price bottom-sticky">{{total.survey_insentif | pointmoney}}</td>
                      <td class="bottom-sticky">{{total.survey_win}}</td>
                      <td class="price bottom-sticky">{{total.survey_win_insentif |pointmoney}}</td>
                      <td class="bottom-sticky">{{total.pasbar}}</td>
                      <td class="price bottom-sticky">{{total.pasbar_insentif | pointmoney}}</td>
                      <td class="bottom-sticky">{{total.reloc}}</td>
                      <td class="price bottom-sticky">{{total.reloc_insentif | pointmoney}}</td>
                      <td class="price bottom-sticky">{{total.insentif | pointmoney}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </template>
          </b-row>
        </b-card>

        <b-card v-if="detail">
          <template v-if="managerDetail">
            <b-row>
            <detail-insentif-manager 
              :typeTicket="detailInsentif.type"
              :detailTicket="detailInsentif.detail"
              :price="detailInsentif.price" 
            />
          </b-row>
          </template>
          <template v-else>
            <b-row>
            <detail-insentif 
            :name="detailInsentif.name"
            :typeTicket="detailInsentif.type"
            :detailTicket="detailInsentif.detail"
            :price="detailInsentif.price"
            />
          </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
    import {getService} from "@/services/get.service";
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment'
    import DetailInsentif from './DetailInsentif'
    import DetailInsentifManager from './DetailInsentifManager'

    export default {
        components: {
            DatePicker,
            DetailInsentif,
            DetailInsentifManager,
        },
        data() {
            return {
                branch: '',
                branchs: [],
                date: Date.now(),
                listInsentif: [],
                manager: {},
                managerDetail: false,
                total: {
                   bongkar: 0,
                   bongkar_insentif: 0,
                   survey: 0,
                   survey_insentif: 0,
                   survey_win: 0,
                   survey_win_insentif: 0,
                   pasbar: 0,
                   pasbar_insentif: 0,
                   insentif: 0,
                   reloc: 0,
                   reloc_insentif: 0
                },
                detailInsentif: {
                    name: '',
                    type: '',
                    detail: '',
                    price: ''
                },
                detail: false,
                start: '',
                end: '',
                selected: 'normal',
                options: [
                  {text: 'Normal', value: 'normal'},
                  {text: 'Custom', value: 'custom'}
                ]
            }
        },
         watch: {
          date: function(val) {
            this.start = moment(val).subtract(1, 'months').format('YYYY-MM-26')
            this.end = moment(val).format('YYYY-MM-25')
          }
        },
        created: function () {
            this.getBranch()
            this.start = moment().subtract(1, 'months').format('YYYY-MM-26')
            this.end = moment().format('YYYY-MM-25')
            let that = this
            if (this.$store.getters.branchInsentif) {
                this.branch = this.$store.getters.branchInsentif
            }else if (this.$store.getters.branchInVendor) {
                this.branch = this.$store.getters.branchInVendor
            } else {
                this.checkBranch = setInterval(() => {
                    that.branch = that.$store.getters.branch
                    if (that.branch) {
                        clearInterval(that.checkBranch)
                    }
                }, 1000);
            }
        },
        methods: {
            async getBranch() {
                try {
                    await getService.list_branch()
                        .then(data => {
                            this.branchs = data
                        })
                } catch (error) {
                    // bila data tidak terpanggil
                }

            },
            getListInsentif(branch, start, end) {
                this.$store.commit('noLoad', true)
                this.total.bongkar = 0
                this.total.bongkar_insentif = 0
                this.total.reloc_insentif = 0
                this.total.reloc = 0
                this.total.survey = 0
                this.total.survey_insentif = 0
                this.total.survey_win = 0
                this.total.survey_win_insentif = 0
                this.total.pasbar = 0
                this.total.pasbar_insentif = 0
                getService.list_insentif_engineer(branch, start, end)
                    .then( data => {
                        this.$store.commit('noLoad', false)
                        this.listInsentif = data.enginer
                        this.manager = data.manager
                        for (let i in data.enginer) {
                          const engineer  = data.enginer[i]
                            this.total.bongkar += engineer.bongkar || 0
                            this.total.bongkar_insentif += engineer.bongkar_insentif || 0
                            this.total.survey += engineer.survey || 0
                            this.total.survey_insentif += engineer.survey_insentif || 0
                            this.total.survey_win += engineer.survey_win || 0
                            this.total.survey_win_insentif += engineer.survey_win_insentif || 0
                            this.total.pasbar += engineer.pasbar || 0
                            this.total.pasbar_insentif += engineer.pasbar_insentif || 0
                            this.total.reloc += engineer.reloc || 0
                            this.total.reloc_insentif += engineer.reloc_insentif
                        }
                        this.total.insentif = this.total.bongkar_insentif + this.total.survey_insentif + this.total.survey_win_insentif + this.total.pasbar_insentif + this.total.reloc_insentif 
                    })
            },
            submit() {
                let start, end
                if (this.selected == 'custom') {
                    start = moment(this.start).format('YYYY-MM-DD')
                    end = moment(this.end).format('YYYY-MM-DD')
                } else {
                    start = moment(this.date, 'x').startOf('month').format('YYYY-MM-DD')
                    end = moment(this.date, 'x').endOf('month').format('YYYY-MM-DD')
                }
                this.getListInsentif(this.branch, start, end)
            },
            OpenDetail(name, type, detail, price, manager = false) {
                this.detail = true
                let idDetail
                if (manager) {
                  idDetail = 'detailInsentifEngineerManager'
                  detail = Object.keys(detail).map(i => detail[i])
                  console.log(detail)
                } else {
                  idDetail = 'detailInsentifEngineer'
                }
                this.detailInsentif.name = name
                this.detailInsentif.type = type
                this.detailInsentif.detail = detail
                this.detailInsentif.price = price
                this.managerDetail = manager 
                 setTimeout(() => {
                document.getElementById(idDetail).scrollIntoView({
                  behavior: 'smooth' 
                });
              }, 500)
            },

        },
        filters: {
          plusRupiah(detail) {
            return detail.replace('= ', '= Rp')
          }
        }
    }
</script>
<style scoped>
    table>tbody>tr>td,
    table>thead>tr>th
    {
        text-align:  center;
        vertical-align: middle;
    }

    .name{
        text-align: left;
    }

    .price{
        text-align: right;
    }

    .b-table-sticky-header > .table.b-table > thead > tr > th {
        background-color: antiquewhite;
    }

    .topHeader{
        top: 47px !important;
    }

    .b-table-sticky-header{
        max-height: 80vh;
    }

    .href{
    color: #20a8d8;
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
    }

    .href:hover{
        color: #167495;
        text-decoration: underline;
    }

    .bottom-sticky{
        bottom: 0;
        position: sticky;
        background-color: aliceblue;
    }
</style>
